import React, { useEffect, useContext, useState, useRef } from "react";
import { FilesContext, LocationContext } from "../contextProvider";
import { TranscriptionWebSocketContext } from "../transcriptionWssProvider"
import { FilesToJSON, formatDateToGreek, sortObjectsByProperty, createFolder, deleteFiles, transcribeFile, moveFiles, pathFromFolderchain, renameFile } from "./functions";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { ActionBar, DeleteElement, LocationBar, NewFolderInput, MoveMenu, RetranscribeElement, RenameMenu } from "./components";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { BACKEND_URL, BASEPATH } from "../global";
import { UploadFile } from "./components/ulpoadFile";
import { UppyModal } from "./components/fileUploader"
import { enqueueSnackbar } from "notistack";
import Layout from "../components/Layout";
import keycloak from '../keycloak';
import Select from 'react-select';
import JustrediLoader from "../components/justrediLoader";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableClickableHead,
    TableHeader,
    TableRow,
    Pagination,
    PaginationContent,
    PaginationEllipsis,
    PaginationItem,
    PaginationLink,
    PaginationNext,
    PaginationPrevious
} from "../shadcnComponents/ui"
import { paginationMenuStyling, paginationMenuTheme, groupsMenuStyling, groupsMenuTheme } from "./reactSelectStyling";

export function FilesBrowser() {
    const navigator = useNavigate();
    const location = useLocation();
    const [filenamesToDelete, setFileNamesToDelete] = useState([])
    const [fileToRetranscribe, setFileToRetranscribe] = useState({ name: '', id: '' })
    // Filename elements, used to ensure same width equal to max content width of wider filename 
    const nameRefs = useRef([]);
    const [maxWidth, setMaxWidth] = useState("auto");
    // Array of selected filenames
    const [selectedFileNames, setSelectedFileNames] = useState([])
    // Array of selected files and folders ids
    const selectedElements = useRef([])
    //Files as they are fetched from the server
    const context = useContext(FilesContext);
    // const userFromContext = useContext(UserContext);
    const user = JSON.parse(localStorage.getItem('user'))
    const [groupManager, setGroupManager] = useState(false)
    // Current Folder Location
    const locationContext = useContext(LocationContext)
    // message state from ws
    const socketMessages = useContext(TranscriptionWebSocketContext)
    // Files after edited with filesToJson function, includes also directory elements
    const [parsedFilesandDirectories, setParsedFilesAndDirectories] = useState(null)
    // Current directory elements
    const [currentDirectoryFiles, setCurrentDirectoryFiles] = useState([{ id: '', name: '' }])
    // List of dir elements from root to current directory
    const [folderChain, setFolderChain] = useState([]);
    // Defined sort method
    const [sortMethod, setSortMethod] = useState({ property: 'modDate', inverse: false })
    const [displayFoldersFirst, setDisplayFoldersFirst] = useState(true)
    // Rows per page -> default = 10
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [pageItemsArray, setPageItemsArray] = useState([[{ id: '', name: '' }]])
    const [page, setPage] = useState(1)
    // current browser location
    const [searchParams, setSearchParams] = useSearchParams();
    // dropdown menu for group allocation
    const [menu, setMenu] = useState([])
    // Groups per file
    const [fileGroups, setFileGroups] = useState(null)
    // Loading page
    const [loading, setloading] = useState(true)
    // File or directory selected to be renamed
    const [fileToRename, setFileToRename] = useState(null)

    useEffect(() => {
        if (!keycloak.authenticated) {
            navigator('/login')
        } else {
            // Fetch files
            fetchData()
            document.addEventListener("mousedown", handleClickAnywhere);
            return () => {
                document.removeEventListener("mousedown", handleClickAnywhere);
            };
        }
    }, []);

    useEffect(() => {
        if (fileToRetranscribe.name != '' && document.getElementById('retranscribe-file').classList.contains('hidden')) {
            document.getElementById('retranscribe-file').classList.remove('hidden')
        } else if (fileToRetranscribe.name == '' && document.getElementById('retranscribe-file') && !document.getElementById('retranscribe-file').classList.contains('hidden')) {
            document.getElementById('retranscribe-file').classList.add('hidden')
        }
    }, [fileToRetranscribe])

    useEffect(() => {
        if (user && user.resource_access) {
            Object.values(user.resource_access).map(each => { if (each.roles[0] == 'Group Manager') { setGroupManager(true) } })
        }
    }, [user])

    function fetchData() {
        // Fetches groups first to avoid race condition and demonstrate groups per file on first loading of the page

        fetch(BACKEND_URL + "/groups", {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${keycloak.token}`
            }
        }).then((r) => r.json())
            .then((re) => {
                if (re != null) {
                    let menuItems = Array.from(re, (group) => { return { label: group.name, value: group.id } })
                    setMenu(menuItems)
                }
                fetch(`${BACKEND_URL}/asr_results/`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${keycloak.token}`
                    }
                })
                    .then((res) => res.json(), (err) => { console.error(err); setloading(false) })
                    .then((fetchedFiles) => {
                        setloading(false)
                        let fileSystem = FilesToJSON(fetchedFiles);
                        if (folderChain.length == 0 && fileSystem.fileMap) {
                            if (location.state && location.state.navigateWithContext && locationContext.folderChain.length > 0) {
                                updateFolderChain(fileSystem.fileMap)
                            } else {
                                let path = searchParams.get("path")
                                // Check if path already in search url parameter
                                if (path) {
                                    let foldernameArray = path.split("/")
                                    let newFolderChain = [fileSystem.fileMap['root']]
                                    let filesArray = Object.values(fileSystem.fileMap)
                                    foldernameArray.map(each => {
                                        if (each != "") {
                                            newFolderChain.push(filesArray.find((el) => el.name == each))
                                        }
                                    })
                                    setFolderChain(newFolderChain)
                                } else {
                                    setFolderChain([fileSystem.fileMap['root']]);
                                }
                            }
                        }
                        setParsedFilesAndDirectories(fileSystem.fileMap)
                        context.resetFileMap(fileSystem, false)
                    })
            }, err => { setloading(false) })
    }

    // Create new folderchain from context with updated ids
    function updateFolderChain(fileMap) {
        let newFolderChain = []
        let oldFolderChain = locationContext.folderChain
        for (let i = 0; i < oldFolderChain.length; i++) {
            for (const [key, value] of Object.entries(fileMap)) {
                if (value.isDir && oldFolderChain[i].name == value.name) {
                    newFolderChain.push(value)
                }
            }
        }
        setFolderChain(newFolderChain)
    }

    // Handle click outside files-table && action-bar
    function handleClickAnywhere(event) {
        const filesTable = document.getElementById("files-table");
        const actionBar = document.getElementById('action-bar')
        const deleteMenu = document.getElementById('delete-file')
        const moveMenu = document.getElementById('move-menu')
        const renameMenu = document.getElementById('rename-menu')
        if (filesTable != event.target && !filesTable.contains(event.target) &&
            actionBar != event.target && !actionBar.contains(event.target) &&
            deleteMenu != event.target && !deleteMenu.contains(event.target) &&
            renameMenu != event.target && !renameMenu.contains(event.target) &&
            moveMenu != event.target && !moveMenu.contains(event.target)
        ) {
            unselectAllElements()
        }
    }

    useEffect(() => {
        window.history.pushState({}, '', BASEPATH + '/home');
        if (folderChain.length > 0 && parsedFilesandDirectories != null) {
            let currentDirectoryElements = []
            let groupsPerFile = {}
            for (const [key, value] of Object.entries(parsedFilesandDirectories)) {
                if (folderChain[folderChain.length - 1].childrenIds.includes(key)) {
                    currentDirectoryElements.push(value)
                    let tempfileGroups = []
                    if (!value.isDir && value.groups) {
                        value.groups.map(groupId => {
                            let element = menu.find(el => el.value == groupId)
                            if (element) { tempfileGroups.push(element) }
                        })
                    } else if (value.isDir && value.childrenIds) {
                        value.childrenIds.map(child => {
                            if (parsedFilesandDirectories[child].isHidden && parsedFilesandDirectories[child].groups) {
                                parsedFilesandDirectories[child].groups.map(groupId => {
                                    let element = menu.find(el => el.value == groupId)
                                    if (element) { tempfileGroups.push(element) }
                                })
                            }
                        })
                    }
                    groupsPerFile[key] = tempfileGroups
                }
            }
            setFileGroups(groupsPerFile)
            setCurrentDirectoryFiles(sortObjectsByProperty(sortMethod, currentDirectoryElements, displayFoldersFirst))
            locationContext.setFolderChain(folderChain)
        }
        setSearchParams({ path: pathFromFolderchain(folderChain) })
    }, [folderChain, parsedFilesandDirectories, menu]);

    // Set width of filename column to max content width for all rows of files browser
    useEffect(() => {
        if (nameRefs.current.length > 0) {
            let widths = []
            nameRefs.current.map(ref => { if (ref && typeof ref.offsetWidth === "number") { widths.push(ref.offsetWidth) } });
            setMaxWidth(Math.max(...widths) + "px");
        }
    }, [currentDirectoryFiles]);

    // set all page elements
    function paginate(items, itemsPerPage) {
        if (!Array.isArray(items)) {
            throw new TypeError("First argument must be an array");
        }
        if (typeof itemsPerPage !== "number" || itemsPerPage + 1 <= 0) {
            throw new Error("Items per page must be a positive integer");
        }

        const pages = [];
        for (let i = 0; i < items.length; i += itemsPerPage) {
            pages.push(items.slice(i, i + itemsPerPage));
        }
        return pages;
    }

    useEffect(() => {
        setPageItemsArray(paginate(currentDirectoryFiles, itemsPerPage))
    }, [currentDirectoryFiles, itemsPerPage])

    useEffect(() => {
        setPage(1)
    }, [pageItemsArray])

    function unselectAllElements() {
        selectedElements.current.map(each => {
            if (document.getElementById(each)) {
                document.getElementById(each).classList.remove('bg-accent')
                document.getElementById(each).classList.remove('selected')
            }
        })
        selectedElements.current = []
        setSelectedFileNames([])
    }

    // Update fileMap with new data
    useEffect(() => {
        if (socketMessages.messageState.type == 'transcription_status') {
            let newFileMap = { ...parsedFilesandDirectories }
            for (const [key, value] of Object.entries(newFileMap)) {
                if (value.interview_id == socketMessages.messageState.asr_result_id) {
                    newFileMap[key].transcriptionStatus = socketMessages.messageState.status
                }
            }
            setParsedFilesAndDirectories(newFileMap)
        }
    }, [socketMessages])

    useEffect(() => {
        setCurrentDirectoryFiles(sortObjectsByProperty(sortMethod, currentDirectoryFiles, displayFoldersFirst))
    }, [sortMethod, displayFoldersFirst])


    // Handle click on element
    function handleClick(event, id) {
        // If tick was clicked, perform no action 

        if (!event.target.closest('.check-symbol') && !event.target.closest('.group-management')) {
            // If ctrl is pressed only select-unselect functionality works
            if (event.ctrlKey) {
                // Add element to selected elements or remove if already selected
                let newSelectedElements = [...selectedElements.current]
                // Unselect element
                if (selectedElements.current.includes(id)) {
                    var index = newSelectedElements.indexOf(id);
                    if (index !== -1) {
                        newSelectedElements.splice(index, 1);
                    }
                    document.getElementById(id).classList.remove('bg-accent')
                    document.getElementById(id).classList.remove('selected')
                } else {
                    // Select element
                    newSelectedElements.push(id)
                    document.getElementById(id).classList.add('bg-accent')
                    document.getElementById(id).classList.add('selected')
                }
                selectedElements.current = newSelectedElements
                setSelectedFileNames(newSelectedElements)
            } else {
                if (event.target.classList.contains('filename')) {
                    //Handled from title element
                } else {
                    // Check if single or double click
                    if (event.detail > 1) {
                        unselectAllElements()
                        // Handle doubleclick
                        if (parsedFilesandDirectories[id].isDir) {
                            setFolderChain([...folderChain, parsedFilesandDirectories[id]])
                        } else {
                            localStorage.setItem('interviewId', parsedFilesandDirectories[id].interview_id)
                            let pathname = window.location.pathname
                            let search = window.location.search
                            window.history.pushState({}, '', BASEPATH + '/home');
                            window.history.pushState({}, '', pathname + search);
                            navigator('/editor', { state: { type: 'database', id: parsedFilesandDirectories[id].interview_id } });
                        }
                    } else {
                        // Handle single click
                        // Unselect element
                        if (selectedElements.current.includes(id)) {
                            unselectAllElements()
                        } else {
                            // Select element
                            selectedElements.current.map(each => {
                                if (document.getElementById(each)) {
                                    document.getElementById(each).classList.remove('bg-accent')
                                    document.getElementById(each).classList.remove('selected')
                                }
                            })
                            selectedElements.current = [id]
                            setSelectedFileNames([id])
                            document.getElementById(id).classList.add('bg-accent')
                            document.getElementById(id).classList.add('selected')
                        }
                    }
                }
            }
        }
    }


    function clickFileName(file) {
        if (file.isDir) {
            setFolderChain([...folderChain, parsedFilesandDirectories[file.id]])
        } else {
            localStorage.setItem('interviewId', parsedFilesandDirectories[file.id].interview_id)
            let pathname = window.location.pathname
            let search = window.location.search
            window.history.pushState({}, '', BASEPATH + '/myFiles');
            window.history.pushState({}, '', pathname + search);
            navigator('/editor', { state: { type: 'database', id: parsedFilesandDirectories[file.id].interview_id } });
        }
    }

    // Handle click on tick symbol
    function clickTick(id) {
        let newSelectedElements = []
        // Remove from selection
        if (selectedElements.current.includes(id)) {
            newSelectedElements = [...selectedElements.current]
            var index = newSelectedElements.indexOf(id);
            if (index !== -1) {
                newSelectedElements.splice(index, 1);
            }
            document.getElementById(id).classList.remove('bg-accent')
            document.getElementById(id).classList.remove('selected')
        } else {
            // Add to selection
            newSelectedElements = [...selectedElements.current, id]
            document.getElementById(id).classList.add('bg-accent')
            document.getElementById(id).classList.add('selected')
        }
        selectedElements.current = newSelectedElements
        setSelectedFileNames(newSelectedElements)
    }

    // Go to selected history directory from navigation bar
    function navigateFromLocationBar(newFolderChain) {
        setFolderChain(newFolderChain)
    }

    // Convert transcription status to readable text
    function returnTranscriptionStatus(status) {
        if (status == 'TRANSCRIBED') {
            return 'Με μεταγραφή'
        } else if (status == 'IN_PROGRESS') {
            return 'Σε επεξεργασία'
        } else {
            return 'Χωρίς μεταγραφή'
        }
    }

    function displayDeleteMenu() {
        let filenames = []
        selectedElements.current.map(each => {
            filenames.push(parsedFilesandDirectories[each].name)
        })
        if (filenames.length == 0) {
            enqueueSnackbar('Δεν έχει επιλεγεί κάποιο αρχείο για διαγραφή', { variant: 'warning', autoHideDuration: 3000 })
        } else {
            setFileNamesToDelete(filenames)
            document.getElementById('delete-file').classList.remove('hidden')
        }
    }

    async function newFolder() {
        let newFileData = await createFolder(document.getElementById('folder-name').value, folderChain, parsedFilesandDirectories);
        setParsedFilesAndDirectories(newFileData.fileMap)
        setFolderChain(newFileData.folderChain)
    }

    async function deleteSelectedElements() {
        let newFileData = await deleteFiles(selectedElements.current, folderChain, parsedFilesandDirectories);
        unselectAllElements()
        document.getElementById('delete-file').classList.add('hidden')
        setParsedFilesAndDirectories(newFileData.fileMap)
        setFolderChain(newFileData.folderChain)
    }

    function handleTranscriptionRequest(elements) {
        let selectedFiles = null
        if (elements) {
            selectedFiles = elements
        } else {
            selectedFiles = selectedElements.current
        }
        if (selectedFiles.length == 0) {
            enqueueSnackbar('Δεν έχει επιλεγεί κανένα αρχείο για μεταγραφή', { variant: 'warning', autoHideDuration: 3000 })
        } else if (selectedFiles.length > 1) {
            enqueueSnackbar('Παρακαλώ επιλέξτε μόνο ένα αρχείο για μεταγραφή', { variant: 'warning', autoHideDuration: 3000 })
        } else {
            if (parsedFilesandDirectories[selectedFiles[0]].isDir) {
                enqueueSnackbar('Δεν μπορεί να σταλεί ένας φάκελος για μεταγραφή', { variant: 'warning', autoHideDuration: 3000 })
            } else if (parsedFilesandDirectories[selectedFiles[0]].transcribed) {
                setFileToRetranscribe({ name: parsedFilesandDirectories[selectedFiles[0]].name, id: parsedFilesandDirectories[selectedFiles[0]].interview_id })
                // enqueueSnackbar('Το αρχείο έχει ήδη σταλεί για μεταγραφή', { variant: 'warning', autoHideDuration: 3000 })
            } else {
                transcribeFile(parsedFilesandDirectories[selectedFiles[0]].interview_id)
            }
        }
    }

    function triggerRenameMenu() {
        if (selectedElements.current.length == 0) {
            enqueueSnackbar('Δεν έχει επιλεγεί κανένα αρχείο για μετονομασία', { variant: 'warning', autoHideDuration: 3000 })
        } else if (selectedElements.current.length > 1) {
            enqueueSnackbar('Παρακαλώ επιλέξτε μόνο ένα αρχείο για μετονομασία', { variant: 'warning', autoHideDuration: 3000 })
        } else {
            setFileToRename(parsedFilesandDirectories[selectedElements.current[0]])
            document.getElementById('file-name').value = parsedFilesandDirectories[selectedElements.current[0]].name
            document.getElementById('rename-menu').classList.remove('hidden')
        }
    }

    async function renameSelectedFile(name) {
        let newFileMap = await renameFile(selectedElements.current[0], parsedFilesandDirectories, name);
        unselectAllElements()
        setParsedFilesAndDirectories(newFileMap)
        // context.resetFileMap(newFileMap, false)
        document.getElementById('rename-menu').classList.add('hidden')
    }

    async function handleMoveFiles(destination) {
        let filesToMove = []
        selectedElements.current.map(each => { filesToMove.push(parsedFilesandDirectories[each]) })
        let newFileData = await moveFiles(filesToMove, folderChain[folderChain.length - 1], destination, parsedFilesandDirectories);
        if (newFileData == null) {
            enqueueSnackbar('Υπήρξε κάποιο πρόβλημα κατά τη μετακίνηση των αρχείων', { variant: 'error', autoHideDuration: 3000 })
            document.getElementById('move-menu').classList.add('hidden')
            selectedElements.current = []
            // Handle http error
        } else if (newFileData == 'childError') {
            // Handle value.name folder to move
            enqueueSnackbar('Η μετακίνηση δεν μπορεί να πραγματοποιηθεί, ο προορισμός βρίσκεται εντός του φακέλου που θέλετε να μετακινήσετε', { variant: 'error', autoHideDuration: 3000 })
        } else {
            setParsedFilesAndDirectories(newFileData)
            updateFolderChain(newFileData)
            document.getElementById('move-menu').classList.add('hidden')
            selectedElements.current = []
        }
    }

    function triggerMoveMenu() {
        if (selectedElements.current.length != 0) {
            document.getElementById('move-menu').classList.remove('hidden')
        } else {
            enqueueSnackbar('Δεν έχει επιλεγεί κάποιο αρχείο ή φάκελος για μεταφορά', { variant: 'warning', autoHideDuration: 3000 })
        }
    }

    function changeSorting(method) {
        if (method == sortMethod.property) {
            setSortMethod({ property: sortMethod.property, inverse: !sortMethod.inverse })
        } else {
            setSortMethod({ property: method, inverse: false })
        }
    }

    async function changeGroup(newGroups, id) {
        try {
            let data = { groups: Array.from(newGroups, group => group.value) }
            let fileId = ''
            if (parsedFilesandDirectories[id].isDir) {
                parsedFilesandDirectories[id].childrenIds.map(each => {
                    if (parsedFilesandDirectories[each].isHidden) {
                        fileId = parsedFilesandDirectories[each].interview_id
                    }
                })
            } else {
                fileId = parsedFilesandDirectories[id].interview_id
            }
            let groups = await fetch(`${BACKEND_URL}/asr_results/${fileId}`, {
                method: 'PATCH',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${keycloak.token}`
                },
            })
            let parsedGroups = await groups.json()
            let groupsPerFile = fileGroups
            let tempfileGroups = []
            parsedGroups.groups.map(groupId => {
                let element = menu.find(el => el.value == groupId)
                if (element) {
                    tempfileGroups.push(element)
                }
            })
            groupsPerFile[id] = tempfileGroups
            setFileGroups(groupsPerFile)
        } catch { e => e }
    }

    return (
        <Layout authenticated={true} sidebar={true}>
            {loading && <JustrediLoader />}
            <div className="w-full flex flex-col pl-2 pr-6">
                <LocationBar folderChain={folderChain} goToDirectory={(value) => { navigateFromLocationBar(value) }} />
                <ActionBar
                    transcribeFile={() => { handleTranscriptionRequest() }}
                    revealNewFolderMenu={() => document.getElementById('new-folder').classList.remove('hidden')}
                    revealDeleteElementMenu={() => { displayDeleteMenu() }}
                    revealFileUploadMenu={() => document.getElementById('modal-upload').classList.remove('hidden')}
                    triggerMoveMenu={() => triggerMoveMenu()}
                    triggerRenameMenu={() => triggerRenameMenu()}
                />
                <div id='files-browser' className="w-full h-fit mt-5">
                    <Table id="files-table" className={`max-h-[${pageItemsArray[page - 1] ? pageItemsArray[page - 1].length * 55 + 39.5 : ''}px]`}>
                        <TableHeader>
                            <TableRow className="text-left cursor-default">
                                <TableHead className="w-[30px] pl-[10px]"></TableHead>
                                <TableClickableHead className="w-[calc(25%-20px)]" inverse={sortMethod.property == "name" && !sortMethod.inverse} onClick={(e) => { changeSorting('name') }}>Όνομα Αρχείου</TableClickableHead>
                                <TableClickableHead className="w-[calc(25%-40px)]" inverse={sortMethod.property == "modDate" && !sortMethod.inverse} onClick={(e) => { changeSorting('modDate') }}>Ημερομηνία μεταφόρτωσης</TableClickableHead>
                                <TableClickableHead className="w-2/12" inverse={sortMethod.property == "transcribed" && !sortMethod.inverse} onClick={(e) => { changeSorting('transcribed') }}>Κατάσταση</TableClickableHead>
                                <TableHead className="w-4/12 pr-[20px]">Ομάδες</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {currentDirectoryFiles.length > 0 && pageItemsArray[page - 1] && pageItemsArray[page - 1].map((each, index) => {
                                if (each && !each.name.startsWith('dummy')) {
                                    return (
                                        <TableRow className='selectable-element group' onClick={(e) => { e.preventDefault(); handleClick(e, each.id) }} key={each.id} id={each.id}>
                                            <TableCell className="w-[20px] pl-[30px]">
                                                <CheckCircleIcon id={`check-${each.id}`} height={25} className={`${document.getElementById(each.id) && document.getElementById(each.id).classList.contains('selected') ? 'visible' : 'invisible'} check-symbol hover:visible group-hover:visible m-auto text-ring`} onClick={(e) => { e.preventDefault(); clickTick(each.id) }} />
                                            </TableCell>
                                            <TableCell className="w-[calc(25%-20px)]">
                                                <div ref={el => nameRefs.current[index] = el} style={{ minWidth: maxWidth }} className="flex flex-row items-center gap-2">
                                                    {each.isDir ?
                                                        <svg xmlns="http://www.w3.org/2000/svg" height={20} width={20} viewBox="0 0 512 512" className="text-accent-foreground">
                                                            <path fill="currentColor" fillOpacity="0.8" strokeLinejoin="round" strokeLinecap="round" d="M64 400l384 0c8.8 0 16-7.2 16-16l0-240c0-8.8-7.2-16-16-16l-149.3 0c-17.3 0-34.2-5.6-48-16L212.3 83.2c-2.8-2.1-6.1-3.2-9.6-3.2L64 80c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16zm384 48L64 448c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l138.7 0c13.8 0 27.3 4.5 38.4 12.8l38.4 28.8c5.5 4.2 12.3 6.4 19.2 6.4L448 80c35.3 0 64 28.7 64 64l0 240c0 35.3-28.7 64-64 64z" />
                                                        </svg>
                                                        :
                                                        <svg xmlns="http://www.w3.org/2000/svg" height={24} viewBox="0 0 384 512" className="text-accent-foreground">
                                                            <path fill="currentColor" fillOpacity="0.8" strokeLinejoin="round" strokeLinecap="round" d="M64 48l112 0 0 88c0 39.8 32.2 72 72 72l88 0 0 240c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zM224 67.9l92.1 92.1-68.1 0c-13.3 0-24-10.7-24-24l0-68.1zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-261.5c0-17-6.7-33.3-18.7-45.3L242.7 18.7C230.7 6.7 214.5 0 197.5 0L64 0zM221.9 267.6c-4.7 10-.3 21.9 9.7 26.6 19.2 8.9 32.4 28.3 32.4 50.8s-13.2 41.9-32.4 50.8c-10 4.7-14.4 16.6-9.7 26.6s16.6 14.4 26.6 9.7C281.2 416.8 304 383.6 304 345s-22.8-71.9-55.6-87.1c-10-4.7-21.9-.3-26.6 9.7zM104 305c-13.3 0-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24l16 0 27.2 34c3 3.8 7.6 6 12.5 6l.3 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-.3 0c-4.9 0-9.5 2.2-12.5 6l-27.2 34-16 0zM223.3 373c9.9-5.4 16.7-16 16.7-28.1s-6.7-22.7-16.7-28.1c-7.8-4.2-15.3 3.3-15.3 12.1l0 32c0 8.8 7.6 16.3 15.3 12.1z" />
                                                        </svg>
                                                    }
                                                    <span className="filename cursor-pointer hover:underline" onClick={() => { clickFileName(each) }}>{each.name}</span>
                                                </div>
                                            </TableCell>
                                            <TableCell className="w-[calc(25%-20px)]">
                                                {formatDateToGreek(each.modDate)}
                                            </TableCell>
                                            <TableCell className="w-2/12">
                                                {!each.isDir && returnTranscriptionStatus(each.transcriptionStatus)}
                                            </TableCell>
                                            <TableCell className="w-4/12 pr-[20px]">
                                                <Select
                                                    className="group-management multiple-dropdown my-auto min-w-[300px] w-full rounded-lg"
                                                    placeholder={'Επιλογή ομάδων'}
                                                    isClearable={false}
                                                    isDisabled={!(groupManager || user != null && each.ownerId == user.sub)}
                                                    isMulti={true}
                                                    isSearchable={true}
                                                    onChange={(e) => { changeGroup(e, each.id) }}
                                                    options={menu}
                                                    defaultValue={fileGroups != null && fileGroups[each.id] && fileGroups[each.id].length > 0 ? fileGroups[each.id] : []}
                                                    theme={groupsMenuTheme}
                                                    styles={groupsMenuStyling}
                                                    components={!(groupManager || user != null && each.ownerId == user.sub) ? { DropdownIndicator: () => null, IndicatorSeparator: () => null } : {}}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            })}
                        </TableBody>
                    </Table>
                    {/* Pagination element */}
                    <div className="w-full flex gap-4 text-sm my-5 pr-[calc(1rem+56px)]">
                        <span className="flex flex-col justify-center ml-auto">Καταχωρήσεις ανά σελίδα</span>
                        <Select className="rounded-lg h-5 my-auto"
                            isDisabled={false}
                            isMulti={false}
                            isSearchable={false}
                            onChange={(e) => { setItemsPerPage(e.value) }}
                            options={[{ label: 5, value: 5 }, { label: 10, value: 10 }, { label: 25, value: 25 }, { label: 50, value: 50 }, { label: 100, value: 100 }]}
                            defaultValue={{ label: 10, value: 10 }}
                            theme={paginationMenuTheme}
                            styles={paginationMenuStyling}
                        />
                        <Pagination className="w-fit mt-auto ml-2">
                            <PaginationContent>
                                <PaginationItem onClick={() => { page > 1 ? setPage(page - 1) : '' }}>
                                    <PaginationPrevious href="#" />
                                </PaginationItem>
                                {pageItemsArray.map(each => {
                                    return (
                                        <PaginationItem key={'page' + pageItemsArray.indexOf(each)} onClick={() => { setPage(pageItemsArray.indexOf(each) + 1) }}>
                                            <PaginationLink href="#" isActive={pageItemsArray.indexOf(each) + 1 == page}>{pageItemsArray.indexOf(each) + 1}</PaginationLink>
                                        </PaginationItem>
                                    )
                                })}
                                {pageItemsArray.length > 4 &&
                                    <PaginationItem>
                                        <PaginationEllipsis />
                                    </PaginationItem>
                                }
                                <PaginationItem onClick={() => { page < pageItemsArray.length ? setPage(page + 1) : '' }}>
                                    <PaginationNext href="#" />
                                </PaginationItem>
                            </PaginationContent>
                        </Pagination>
                    </div>
                </div>
                <UppyModal fileMap={parsedFilesandDirectories} updateFileMap={setParsedFilesAndDirectories} folderChain={folderChain} updateFolderChain={setFolderChain} />
                <MoveMenu fileMap={parsedFilesandDirectories} currentLocation={folderChain[folderChain.length - 1]} handleClick={handleMoveFiles} selectedFiles={selectedFileNames} clearSelected={() => { selectedElements.current = [] }} />
                <NewFolderInput createFolder={() => { newFolder() }} />
                <RenameMenu fileToRename={fileToRename} unsetNameToRename={() => { setFileToRename(null) }} renameSelected={renameSelectedFile} />
                <DeleteElement unsetNamesToDelete={() => { setFileNamesToDelete([]) }} namesToDelete={filenamesToDelete} deleteSelected={() => { deleteSelectedElements() }} />
                <UploadFile path={folderChain} fileMap={parsedFilesandDirectories} updateFileMap={setParsedFilesAndDirectories} folderChain={folderChain} updateFolderChain={setFolderChain} />
                <RetranscribeElement transcribeSelected={() => { transcribeFile(fileToRetranscribe.id) }} fileToRetranscribe={fileToRetranscribe} unsetNameToRetranscribe={() => { setFileToRetranscribe({ name: '', id: '' }) }} />
            </div>
        </Layout>
    );
}

export default FilesBrowser;
